import React, { memo } from 'react';
import { Button } from '@miroculus/nucleo';
import { Log } from '@miroculus/miroculus-ui';
import classnames from 'classnames/bind';
import CodeEditor from '../CodeEditor/CodeEditor';
import styles from './IDE.scss';
const cx = classnames.bind(styles);
export const THEMES = {
    light: 'base16-light',
    dark: 'base16-dark',
};
const IDE = ({ onScriptChange, script = '', theme = THEMES.light, registry = [], sources = {}, onScriptRun, line = { number: -1, status: 0 }, status = 0, showLogSources = true, onThemeToggle, running = false, onSendScriptAsProtocol, onScriptStop, onSendScriptAsQC, showStopButton = false, readOnly = false, hintItems, }) => {
    return (React.createElement("div", { className: cx('container') },
        React.createElement("div", { className: cx('editorContainer', theme) },
            React.createElement(CodeEditor, { onScriptChange: onScriptChange, script: script, theme: theme, line: line, status: status, onThemeToggle: onThemeToggle, onScriptRun: onScriptRun, onScriptStop: onScriptStop, readOnly: readOnly, hintItems: hintItems })),
        React.createElement("div", { className: cx('buttonsContainer', theme) },
            React.createElement(Button, { size: "small", onClick: onScriptRun, disabled: !script.trim() || running }, "Run"),
            showStopButton && (React.createElement(Button, { flavor: "secondary", size: "small", onClick: onScriptStop, disabled: !running }, "Stop"))),
        React.createElement("div", { className: cx('loadContainer', theme) },
            React.createElement("div", { className: cx('mainContainer') },
                React.createElement("div", { className: cx('title') },
                    React.createElement("p", null, "Load script")),
                React.createElement(Button, { flavor: "secondary", "data-testid": "send-as-qc-button", onClick: onSendScriptAsQC, disabled: !script.trim() || running, size: "xsmall" }, "As QC"),
                React.createElement(Button, { flavor: "secondary", "data-testid": "send-as-protocol-button", onClick: onSendScriptAsProtocol, disabled: !script.trim() || running, size: "xsmall" }, "As protocol"))),
        React.createElement("div", { className: cx('logContainer') },
            React.createElement(Log, { onSourceToggle: () => {
                    /* we dont do anything */
                }, registry: registry, sources: sources, showSources: showLogSources }))));
};
export default memo(IDE);
